import { createSlice } from "@reduxjs/toolkit";

let fakeData = [
  {
    id: "schedule-office-hours",
    version: 1,
    name: "Office-Hours",
    profileType: "wireless",
    displayFormat: "24-hour",
    days: [
      { day: "SUNDAY", startTime: "00:00", endTime: "08:00", availability: true },
      { day: "MONDAY", startTime: "00:01", endTime: "08:00", availability: true },
      { day: "TUESDAY", startTime: "23:59", endTime: "08:00", availability: true },
      { day: "WEDNESDAY", startTime: "09:00", endTime: "22:00", availability: true },
      { day: "THURSDAY", startTime: "00:00", endTime: "08:00", availability: true },
      { day: "FRIDAY", startTime: "00:00", endTime: "08:00", availability: true },
      { day: "SATURDAY", startTime: "23:00", endTime: "06:00", availability: true },
    ],
  },
  {
    id: "schedule-after-hours",
    version: 1,
    name: "After-Hours",
    profileType: "wireless",
    displayFormat: "24-hour",
    days: [
      { day: "SUNDAY", startTime: "18:00", endTime: "23:59", availability: true },
      { day: "MONDAY", startTime: "18:00", endTime: "23:59", availability: true },
      { day: "TUESDAY", startTime: "18:00", endTime: "23:59", availability: true },
      { day: "WEDNESDAY", startTime: "18:00", endTime: "23:59", availability: true },
      { day: "THURSDAY", startTime: "18:00", endTime: "23:59", availability: true },
      { day: "FRIDAY", startTime: "18:00", endTime: "23:59", availability: true },
      { day: "SATURDAY", startTime: "00:00", endTime: "23:59", availability: true },
    ],
  },
  {
    id: "schedule-weekend-only",
    version: 1,
    name: "Weekend-Only",
    profileType: "wireless",
    displayFormat: "24-hour",
    days: [
      { day: "SUNDAY", startTime: "00:00", endTime: "23:59", availability: true },
      { day: "MONDAY", startTime: "00:00", endTime: "00:00", availability: false },
      { day: "TUESDAY", startTime: "00:00", endTime: "00:00", availability: false },
      { day: "WEDNESDAY", startTime: "00:00", endTime: "00:00", availability: false },
      { day: "THURSDAY", startTime: "00:00", endTime: "00:00", availability: false },
      { day: "FRIDAY", startTime: "00:00", endTime: "00:00", availability: false },
      { day: "SATURDAY", startTime: "00:00", endTime: "23:59", availability: true },
    ],
  },
];

const initialState = {
  resource: "schedule",
  data: [...fakeData],
};

export const profilesScheduleSlice = createSlice({
  name: "profilesSchedule",
  initialState,
  reducers: {
    setScheduleProfilesData: (state) => {
      state.data = [...fakeData];
    },
    setScheduleProfileData: (state, action) => {
      const profileScheduleId = action.payload.profileScheduleId;

      state.data = fakeData.find((item) => item.id === profileScheduleId) ?? null;
    },
    createScheduleProfile: (state, action) => {
      const payload = action.payload.data ?? action.payload;
      const newSchedule = {
        ...payload,
        id: `schedule-${(fakeData.length + 1).toString().padStart(3, "0")}`,
        version: 1,
      };

      fakeData = [...fakeData, newSchedule];
      state.data = [...fakeData];
    },
    updateScheduleProfile: (state, action) => {
      const payload = action.payload.data ?? action.payload;
      const profileScheduleId = action.payload.profileScheduleId || payload.id;
      const index = fakeData.findIndex((item) => item.id === profileScheduleId);

      if (index !== -1) {
        fakeData[index] = {
          ...fakeData[index],
          ...payload,
          id: profileScheduleId,
        };
        state.data = [...fakeData];
      }
    },
    deleteScheduleProfile: (state, action) => {
      const payload = action.payload.data ?? action.payload;
      const ids = payload.scheduleProfileIds ?? [];

      fakeData = fakeData.filter((item) => !ids.includes(item.id));
      state.data = [...fakeData];
    },
  },
});

export const {
  setScheduleProfilesData,
  setScheduleProfileData,
  createScheduleProfile,
  updateScheduleProfile,
  deleteScheduleProfile,
} = profilesScheduleSlice.actions;

export default profilesScheduleSlice.reducer;
